import SubcategoryPage from '@/components/template/SubcategoryPage';

const Feel = () => {
  const products = [
    {
      title: "Feel Model 1",
      imageSrc: "https://images.unsplash.com/photo-1603204077587-a3e570be71a9?auto=format&fit=crop&q=80",
      url: "/ogledala/feel/model-1"
    },
    {
      title: "Feel Model 2",
      imageSrc: "https://images.unsplash.com/photo-1589798312990-ea8f06163835?auto=format&fit=crop&q=80",
      url: "/ogledala/feel/model-2"
    },
    {
      title: "Feel Model 3",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/feel/model-3"
    },
    {
      title: "Feel Model 4",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/feel/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Feel"
      description="Ogledala, ki vzbujajo čustva in povezujejo prostor. Senzorično oblikovanje za prostore, ki jih ne boste le videli, temveč tudi čutili."
      heroImage="https://images.unsplash.com/photo-1603204077587-a3e570be71a9?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Feel;